namespace Worthington.Locations {
    let latitude: number = 0;
    let longitude: number = 0;
    let baseUrl: string = null;
    let apiKey: string = null;

    const getCurrentLatitudeLongitude = (callback) => {
        let viewAll = (document.getElementById('ViewAll') as HTMLInputElement).value.toLowerCase() === 'true';

        navigator.geolocation.getCurrentPosition(function(position) {
            latitude = position.coords.latitude;
            longitude = position.coords.longitude;

            if (!viewAll) {
                // Get locations based on lat/long
                if (callback) callback();
            }
        });
    };

    const getLocations = (callback = null) => {
        // Get user selections
        let business = (document.getElementById('Business') as HTMLInputElement).value;
        let country = (document.getElementById('Country') as HTMLInputElement).value;
        let region = (document.getElementById('Region') as HTMLInputElement).value;
        let state = (document.getElementById('State') as HTMLInputElement).value;

        // Construct URL based on selections
        const url = `${baseUrl}/results?latitude=${latitude}&longitude=${longitude}&business=${business}&country=${country}&region=${region}&state=${state}`;

        // Load div tag with results
        fetch(url)
            .then(response => response.text())
            .then(data => {
                document.getElementById('locationResults').innerHTML = data;
                setupFiltering();
                if (callback) callback();
            });
    };

    const setupFiltering = () => {
        document.querySelectorAll('.js-dropdown').forEach(item => {
			item.addEventListener('change', event => {
				getLocations();
			});
		});

        // HOLDING ON THE ADDRESS IMPLEMENTATION
        // document.getElementById('locationSearch').addEventListener('keyup', (event) => {
        //     if (event.key === 'Enter') {
        //         let address = (event.target as HTMLInputElement).value;

        //         fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${apiKey}`)
        //             .then(response => response.json())
        //             .then(data => {
        //                 if (data.results) {
        //                     latitude = data.results[0].geometry.location.lat;
        //                     longitude = data.results[0].geometry.location.lng;

        //                     // Refresh list of locations based on lat/long
        //                     getLocations(() => {
        //                         // Add the address back after refresh
        //                         (document.getElementById('locationSearch') as HTMLInputElement).value = address;
        //                     });
        //                 }
        //             });
        //     }
        // });

        // Update Maps
        setupGoogleMaps();
    };

    const setupGoogleMaps = () => {
        let mapOptions = {
            center: new google.maps.LatLng(30, -25),
            zoom: 2,
            disableDefaultUI: true,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        let map = new google.maps.Map(document.getElementById('map'), mapOptions);
        let infowindow = new google.maps.InfoWindow();
        let bounds = new google.maps.LatLngBounds();
        let pinSVGHole = "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z";
        let pinColor = '#81bc00'; // default pin color for corporate
        let locations = document.querySelectorAll('.js-location');
        let center;

        locations.forEach(item => {
            let location = item as HTMLElement;
            let locationLat = parseFloat(location.dataset.latitude);
            let locationLong = parseFloat(location.dataset.longitude);
            let position = new google.maps.LatLng(locationLat, locationLong);
            let business = location.dataset.business;
            let contentMarker = location.querySelector('.js-map-marker');

            if (business === 'consumerProducts') {
                pinColor = '#d29f13';
            } else if (business === 'buildingProducts') {
                pinColor = "#0072ce";
            } else if (business === 'sustainableEnergySolutions') {
                pinColor = "#00B2a9";
            } else if (business === 'steelProcessing') {
                pinColor = "#54565b"; //$gray-dark
            } else if (business === 'other') {
                pinColor = "#ba271f"; //$red
            } else if (business === 'globalHeadquarters') {
                pinColor = "#000000"; //$green
            }

            contentMarker.setAttribute("fill", pinColor);

            let markerImage = {
                path: pinSVGHole,
                anchor: new google.maps.Point(12,17),
                fillOpacity: 1,
                fillColor: pinColor,
                strokeWeight: 2,
                strokeColor: "white",
                scale: 2
            };

            let marker = new google.maps.Marker({
                position: position,
                map: map,
                animation: google.maps.Animation.DROP,
                icon: markerImage
            });

            bounds.extend(position);
            center = position;

            google.maps.event.addListener(marker, 'click', (function(marker) {
                return function() {
                  infowindow.setContent(location.innerHTML);
                  infowindow.open(map, marker);
                }
            })(marker));
        });

        if (locations.length > 1) {
            map.fitBounds(bounds);
        } else {
            map.setCenter(center);
            map.setZoom(11);
        }
    };

    export const init = () => {

        let locationResults = document.getElementById('locationResults');
        baseUrl = locationResults.dataset.baseurl;
        apiKey = locationResults.dataset.apikey;

        getCurrentLatitudeLongitude(getLocations);
        setupFiltering();
        setupGoogleMaps();
	};
}

document.addEventListener("DOMContentLoaded", () => {
	Worthington.Locations.init();
});
